import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { fetchPageDetails } from '../redux/slice/themeSlice';
import { encryptData, getItem } from '../utils/utils';
import { LoadingOutlined } from '@ant-design/icons';
import CustomButton from '../common/CustomButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const AccessibilityPage = (props) => {
  const { loading, pageDataDetails, fetchPageDetails } = props;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const accessKeys = getItem('accessKeys');
    const apiData = {
      P_PAGE_NAME: 'accessibility',
      P_CLIENT_ID: accessKeys?.P_CLIENT_ID,
      P_ACCESS_KEY: accessKeys?.P_ACCESS_KEY,
      LANG_CODE: i18n.language.toUpperCase(),
    };
    const encryptedPayload = encryptData(apiData);
    fetchPageDetails(encryptedPayload);
  }, []);
  const topBackClick = () => {
    navigate('/collection-day');
  };
  return (
    <div>
      <div className="container-xxl">
        {' '}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center container-xxl" style={{ height: '100vh' }}>
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <>
            <div className="me-2" style={{ color: '#1F70B8', fontSize: '20px' }}>
              {`< `}
              <CustomButton onClick={topBackClick} disable={false}>
                {` ${t('back')}`}
              </CustomButton>
            </div>
            <div dangerouslySetInnerHTML={{ __html: pageDataDetails?.P_PAGE_TEXT }}></div>
          </>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = ({ themeSlice }) => {
  const { loading, pageDataDetails } = themeSlice;
  return { loading, pageDataDetails };
};

const mapDispatchToProps = { fetchPageDetails };
export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityPage);
